import termsAndConditions from "../assets/pdf/terms_and_conditions.pdf";
export const contactsData = {
  email: "dominikamrozfiz@gmail.com",
  phone: "+48 509 024 175",
  address1: "Trenuj Świadomie ul. Słupecka 4 lok.37, Warszawa 02-309 ",
  address2: "Decepticon GYM ul. Sadowa 4, Warszawa-Wesoła 05-077 ",
  termsPdf: termsAndConditions,

  sheetAPI: "",
};
